import React, { Component } from "react";
import Header from "../components/header";
import Footer from "../components/footer";
import "./about.css";
import { Link } from "react-router-dom";
import InfoCard from "../components/InfoCard";

class About extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showButton: false, // Initially hidden
    };
  }

  componentDidMount() {
    console.log("Component mounted - Adding scroll event listener"); // Debugging log
    window.addEventListener("scroll", this.handleScroll);
  }

  componentWillUnmount() {
    console.log("Component unmounted - Removing scroll event listener"); // Debugging log
    window.removeEventListener("scroll", this.handleScroll);
  }

  handleScroll = () => {
    console.log("User scrolled, Y Position:", window.scrollY); // Debugging log

    if (window.scrollY > 300) {
      console.log("Showing Back to Top button"); // Debugging log
      this.setState({ showButton: true });
    } else {
      console.log("Hiding Back to Top button"); // Debugging log
      this.setState({ showButton: false });
    }
  };

  scrollToTop = () => {
    console.log("Scrolling back to top"); // Debugging log
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  render() {
    return (
      <div>
        <Header />

        <div className="about-hero">
          <div className="about-hero-content container">
            <h1>The system</h1>
            <p>
              <Link to="/" className="about-breadcrumb-home">
                Home
              </Link>
              <span className="about-breadcrumb-separator"> / </span>
              <span className="about-breadcrumb-current"> The system</span>
            </p>
          </div>
        </div>

        <div className="container">
          <p style={{ paddingTop: "100px" }}></p>
          <div className="text-center">
            <h1 className="" style={{ fontWeight: "800" }}>
              {" "}
              The Wealth System{" "}
            </h1>

            <div
              className="site-text-color pb-2"
              style={{ marginTop: "-5px", fontSize: "21px" }}
            >
              Transform Your Efforts into Limitless Wealth
            </div>
          </div>

          <div className="row">
            <div
              className="col-lg-6 col-md-12 col-sm-12 about-text "
              style={{ textAlign: "justify", fontSize: "18px" }}
            >
              <p style={{ paddingTop: "10px" }}></p>
              <b style={{ fontSize: "30px" }}>T</b>his is a cultivation platform
              created by a team of renowned financial experts with the sole aim
              of moving all dedicated wealth cultivators into opulence,
              leveraging on users ability to efficiently and effectively utilize
              the four major Cultivation inputs; time, power of persuasion, data
              and cultivation realms access fees to accomplish task assigned at
              every Cultivation Realm. These inputs efficient and conservative
              utilization maximizes users&apos; cultivation and brings
              unimaginable financial rewards from the System.
              <p style={{ paddingTop: "20px" }}>
                Any system that promises a reward amount that exceeds its
                cumulative revenue at any given level is fraudulent and should
                be avoided because there is no free lunch, anywhere. The greedy
                always want to reap from where they did not sow and are always
                caught up in fraudulent platforms that promise a million times
                return on their financial input without work. Here, users must
                work to earn through task performance and every earnings on this
                platform, including Bonus rewards and grants are settled from
                cultivation realms access fees, advert placement charges and
                earnings from games played within the system, making it a self
                sustaining wealth system.
              </p>
              <p style={{ paddingTop: "20px" }}>
                However, Cultivation in this platform involves performing task
                as provided by the System at any given cultivation realm, with
                commensurate financial rewards upon task accomplishment. 1st
                cultivation Realm assignment is sharing of your system Link to
                your friends and acquaintances via social media platforms,
                inviting them to join the system and experience opulence. Follow
                up your referrals and also do not forget to share the
                system&apos;s love upon sign up.
              </p>
              <p style={{ paddingTop: "20px" }}>
                The following table represents the maximum system rewards for
                the different cultivation realms cumulatively, upon 100% task
                accomplishment up to 5th down line referral level, all things
                being equal (meaning that all referrals were able to accomplish
                their task up to 100% too, to the 5th down line).
              </p>
            </div>
            <div
              className="col-lg-6 col-md-12 about-text d-none d-md-none d-lg-block"
              style={{ textAlign: "justify" }}
            >
              <div className="image-container">
                <img src="wealth_logo.png" style={{ width: "100%" }} />
                <div className="image-1"></div>
                <div className="image-2"></div>
                <div className="image-3"></div>
              </div>
            </div>
          </div>
        </div>

        <div className="pt-5">
          <div className="container text-start">
            <div className="row">
              <div
                className="col-lg-12 col-md-12 col-sm-12 about-text "
                style={{ textAlign: "justify" }}
              >
                <b
                  style={{
                    backgroundColor: "#79dc3f",
                    padding: "10px 20px",
                    overflow: "auto",
                    borderRadius: "8px 8px 0px 0px",
                  }}
                >
                  cultivation Levels & Earnings Breakdown{" "}
                </b>
                <div
                  className=" "
                  style={{
                    backgroundColor: "#79dc3f",
                    padding: "20px",
                    overflow: "auto",
                    borderRadius: " 0px 8px 8px 8px",
                  }}
                >
                  <img src="table-ngn.png" style={{ width: "100%" }} />
                </div>
              </div>
              {/* <div className="col-lg-6 col-md-12 col-sm-12 about-text " style={{textAlign:"justify"}}>
               <b style={{backgroundColor:"#79dc3f", padding:"10px 20px", overflow:"auto", borderRadius:"8px 8px 0px 0px"}}>cultivation Levels & Earnings Breakdown </b>
               <div className=" " style={{backgroundColor:"#79dc3f", padding:"20px", overflow:"auto",  borderRadius:" 0px 8px 8px 8px"}}>
              <img src="table-ngn.png" style={{width:"100%"}}/>
              </div>
            </div> */}
            </div>
          </div>
        </div>

        <div className="pt-5">
          <div className="container text-start">
            <p style={{ paddingTop: "20px", fontSize: "18px" }}>
              The above figures are not fictitious but actual cumulative
              realizable reward for every committed user, whose down lines are
              performing maximum task, provable to all doubting Thomas and
              pessimists upon request via admin on Whatsapp or email. It is
              mandatory that every user should establish a business capable of
              employing not less than 3 persons with a GPRS images uploaded as
              proof of compliance, upon receipt of an amount in excess of twenty
              million naira or its dollar equivalent from the wealth system
              platform. This serves as a payback and appreciation to the society
              from whose input the system is rewarding users. The System
              reserves the right to suspend temporarily the accounts of non
              complying users in one month after receiving notification or
              permanently after three months upon notification receipt.
            </p>
          </div>
        </div>

        <div className=" ext2 bg-team mt-5">
          <div className="location pt-5 pb-4 ">
            <div className="pane   " style={{ textAlign: "justify" }}>
              <div className="row">
                <div
                  className="col-lg-6  pe-3 px-3 pb-4 "
                  style={{ fontSize: "20px" }}
                >
                  <InfoCard
                    img="ext1.jpg"
                    title="Our Mission"
                    content="Create a perfect self sustainable wealth redistribution system where people, 
through task accomplishment can enrich each other financially via support and 
encouragement to the extent of raising so many millionaire industrialists in the 
shortest possible time who will in turn appreciate the society through industrial 
development targeted to create massive jobs and eradicate poverty"
                    color="#278c64c2"
                  />
                </div>

                <div
                  className="col-lg-6  pe-3 px-3 pb-4 "
                  style={{ fontSize: "20px" }}
                >
                  <InfoCard
                    img="ext1.jpg"
                    title="Our Vision"
                    content="To take so many people out of poverty by raising hundreds of millionaires 
annually, train them on industrial skills of their choice and support those who 
excellently passed our competent test establish their industries through cash 
grants and or partnership."
                    color="#278c64c2"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="pt-5">
          <div className="container text-start">
            <div className="pt-5">
              <div className="row">
                <div className="col-lg-5">
                  <img src="people.svg" style={{ width: "100%" }} />
                </div>
                <div className="col-lg-7" style={{ fontSize: "18px" }}>
                  <p style={{ paddingTop: "20px" }}>
                    <b style={{ fontSize: "30px" }}>O</b>nce eight persons sign
                    up through any user&apos;s referral link and pay up their
                    cultivation realm&apos;s access fees, the system
                    automatically migrates the user to the next Cultivation
                    Realm, for higher level cultivation while he/she is still
                    cultivating on the former realm to complete a 100% task. At
                    this new realm, the system does the task for the user.
                    <br />
                    <br />
                    Getting only eight direct referrals at any realm should not
                    stop user cultivation because the maximum referral limit is
                    twenty. It is very pertinent to note that allowing any of
                    your direct referrals to migrate higher realm before you
                    means temporally losing 40% of his/her cultivation access
                    fees and cultivation rewards at that new realm until you
                    migrate too. Then the rewards are released along with other
                    accumulated benefits.
                    <br />
                    <br />
                    Cultivation rewards come as 40% of your direct referrals
                    cultivation realm access fees, together with 40% of their
                    subsequent cultivation rewards, being 40% of whatever their
                    own direct referrals earn. Rewards happen at every
                    cultivation realm with its own unique experience due to
                    access fees differentials. Always remember that the higher
                    the cultivation realms, the higher the access fees and also
                    the higher the financial rewards.
                  </p>
                </div>

                <div className="col-lg-12" style={{ fontSize: "18px" }}>
                  <p style={{ paddingTop: "20px" }}>
                    The system presently has twelve cultivation realms, each
                    with different reward experience. The sixth cultivation
                    realm qualifies investors to Bonus rewards access upon 100%
                    task completion up to that realm. The twelfth cultivation
                    realm access qualifies investors to participate in an online
                    skills acquisition program and subsequently receive business
                    start up grants upon completion of all the realms
                    assignments. Existence realms are infinite and appearances
                    of extra higher realms are functions of users&apos; rate of
                    cultivation and migration Speed. Traversing within realms of
                    lower cultivation to achieve 100% task accomplishment after
                    migration is very necessary as such movement will enhance
                    wealth expansion exponentially.
                  </p>
                </div>

                <div className="col-lg-12" style={{ fontSize: "18px" }}>
                  <p style={{ paddingTop: "20px" }}>
                    The rewards can be withdrawn from the dashboard upon
                    reaching a minimum withdrawal threshold of N10,000 and can
                    also be used for paying up cultivation access fees for
                    higher realms. The system reserves exclusive 1% stake
                    holding right jointly to the first one hundred cultivators
                    to reach the twelfth realm, with 100% task accomplishment,
                    at negotiable price, outside their normal cultivation reward
                    earnings. This shareholding opportunity is an appreciative
                    gesture to the relentless cultivators who never doubted the
                    system&apos;s credibility and invested their Time,
                    Persuasion ability, Data and Access Fee on the WEALTH
                    SYSTEM.
                    <br />
                    <br />
                    This unlimited wealth creation system is designed to take as
                    much people as are willing to give the system a chance via
                    participation, having gone through series of disappointments
                    from other platforms with humongous benefit listings and
                    unfulfilled financial promises, out of poverty through
                    income redistribution amongst the teaming populace using its
                    simple referral system. Making N50,000.00 as cultivation
                    reward on your first day of sign up or more than N500,000.00
                    in your first week a child&apos;s play if you are dedicated
                    in cultivation.
                  </p>
                </div>

                <div className="col-lg-7" style={{ fontSize: "18px" }}>
                  <p style={{ paddingTop: "20px" }}>
                    This credible, effective and secured cultivation platform
                    was created by Rauxmac Integrated Concepts, a deep creative
                    thinking group, an idea identification, development and
                    promotion company in collaboration with financial experts,
                    primarily to heal those whose hearts were broken because of
                    negative cultivation experiences, after in-depth study and
                    critical analysis of so many failed cultivation schemes,
                    causing cultivators to lose their hard earned money, leading
                    to high level distrust and consequential fear of investing
                    on online wealth creation platforms anymore.
                    <br />
                    <br />
                    The optimists rule the world economically because they see
                    beyond the present and do not miss genuine cultivation
                    opportunities irrespective of past failures and
                    disappointments. Rebuke that pessimistic voice of fear
                    trying to becloud your sense of judgment with negativity and
                    limit your financial prosperity through constantly reminding
                    you of past disappointments, thereby denying you a once in a
                    life time opportunity to break free from poverty and
                    economic stagnation.
                    <br />
                    <br />
                  </p>
                </div>
                <div className="col-lg-5" style={{ fontSize: "20px" }}>
                  <img
                    src="refer.svg"
                    style={{ width: "100%", marginTop: "-15px" }}
                  />
                </div>

                <div className="col-lg-12" style={{ fontSize: "18px" }}>
                  Join now and benefit from the most credible, effective, user
                  friendly and efficient cultivation scheme with proven records
                  of rewards promise delivery and guaranteed pay out mechanism
                  and enjoy unlimited financial prosperity with little
                  cultivation.
                </div>
              </div>
            </div>
          </div>
        </div>

        <p style={{ paddingTop: "50px" }}></p>
        {/* MORE INFO SECTION */}

        <div className=" ext2  mt=5">
          <div className="location pt-5 aboutInfo  container-fluid">
            <div>
              <p style={{ paddingTop: "50px" }}></p>

              <div
                className="text-warning"
                style={{
                  fontSize: "30px",
                  fontWeight: "700",
                }}
              >
                More About The Wealth System
              </div>
            </div>

            <div className="pane pt-5 pb-5" style={{ textAlign: "justify" }}>
              <div className="row">
                <div
                  className="col-lg-12 pe-3 px-3 pb-4 "
                  style={{ fontSize: "20px" }}
                >
                  <InfoCard
                    img="grm1.jpg"
                    title="Online skills acquisition program for accomplished cultivators with start off 
financial grants"
                    content="The system shall provide an online training program on relevant fields of interest to all the accomplished investors, being those that have migrated to the highest cultivation realm and have also completed 100% of their task across cultivation realms. Start off grants shall also be granted to those that passed quizzes in relation to skill trainings received, from 60% and above. The System shall also accommodate users who have received rewards in excess of twenty million naira or its dollar equivalent upon application for training on skills along with the above. Though the later are not qualified for financial grants but may go into partnership with the System upon submission of good business proposal via System admin."
                    color="#101316c2"
                  />
                </div>
                <div
                  className="col-lg-6  pe-3 px-3 pb-4 "
                  style={{ fontSize: "20px" }}
                >
                  <InfoCard
                    img="grm.jpg"
                    title="System's Free Bonus rewards  Eligibility"
                    content="Once you get to sixth cultivation realm and have completed the accompanying 
task, you are qualified to get a onetime Bonus rewards of an amount not exceeding 50% of
your un-withdrawn wallet balance as at the time of request, recoverable from 
future income earned as cultivation rewards from the system. So you don't need 
to borrow to pay back."
                    color="#101316c2"
                  />
                </div>

                <div
                  className="col-lg-6  pe-3 px-3 pb-4 "
                  style={{ fontSize: "20px" }}
                >
                  <InfoCard
                    img="grm2.jpg"
                    title="Our System Team:"
                    content="Our dedicated support team works 24/7, making sure that users' needs are met 
in real time. Mails are discretely handled and doubts are also cleared through 
our comprehensive approach to problems solving and clear cut answers to 
questions. Get help and support from the team and also feel very free to inform 
us of any issue that you feel requires proper analyses via any of our emails, 
admin@wealthsystem.net, support@wealthsystem.net etc."
                    color="#101316c2"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer />

        {/* BACK TO TOP BUTTON */}
        {this.state.showButton && (
          <button className="back-to-top" onClick={this.scrollToTop}>
            ↑
          </button>
        )}
      </div>
    );
  }
}

export default About;
